import React from 'react';
import { Input } from '../../../../../components/ui/input';
import { Label } from '../../../../../components/ui/label';

const SLOPE_TIME_LIMIT = 10;

export type ManualWeldingSettingsValues = {
  slopeTimeIn: string;
  slopeTimeOut: string;
  minimumWeldTime: string;
};

type ManualWeldingSettingsFieldsProps = ManualWeldingSettingsValues & {
  disabled?: boolean;
  onSlopeTimeInChange: (value: string) => void;
  onSlopeTimeOutChange: (value: string) => void;
  onMinimumWeldTimeChange: (value: string) => void;
};

export const ManualWeldingSettingsFields: React.FC<ManualWeldingSettingsFieldsProps> = ({
  slopeTimeIn,
  slopeTimeOut,
  minimumWeldTime,
  disabled = false,
  onSlopeTimeInChange,
  onSlopeTimeOutChange,
  onMinimumWeldTimeChange,
}) => (
  <>
    <div className="space-y-1.5 min-w-0">
      <Label className="text-[12px] font-medium text-text-grey">Slope Time (sec)</Label>
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-1.5 flex-1">
          <span className="text-[11px] text-heritage-grey">In</span>
          <Input
            type="number"
            value={slopeTimeIn}
            onChange={(event) => onSlopeTimeInChange(event.target.value)}
            className="text-center text-[12px] h-9"
            placeholder="0"
            disabled={disabled}
            min={-SLOPE_TIME_LIMIT}
            max={SLOPE_TIME_LIMIT}
            step="0.1"
          />
        </div>
        <div className="flex items-center gap-1.5 flex-1">
          <span className="text-[11px] text-heritage-grey">Out</span>
          <Input
            type="number"
            value={slopeTimeOut}
            onChange={(event) => onSlopeTimeOutChange(event.target.value)}
            className="text-center text-[12px] h-9"
            placeholder="0"
            disabled={disabled}
            min={-SLOPE_TIME_LIMIT}
            max={SLOPE_TIME_LIMIT}
            step="0.1"
          />
        </div>
      </div>
    </div>

    <div className="space-y-1.5 min-w-0">
      <Label className="text-[12px] font-medium text-text-grey">Minimum Weld Time (sec)</Label>
      <Input
        type="number"
        value={minimumWeldTime}
        onChange={(event) => onMinimumWeldTimeChange(event.target.value)}
        className="text-center text-[12px] h-9"
        placeholder="0.0"
        disabled={disabled}
        min={0}
        step="0.1"
      />
    </div>
  </>
);
